document.addEventListener("DOMContentLoaded", function () {


  // all slider
  window.SplideSliderFunction = function () {
    document.querySelectorAll('.splide:not(.no-custom-arrow):not(.CenterMoodSlider):not(.marquee-slider)').forEach((element) => {
      const perPage = parseInt(element.dataset.perPage) || 1;
      const gap = element.dataset.gap || '24px';
      const drag = element.dataset.drag === 'true';
      const arrows = element.dataset.arrows === 'true';
      const direction = element.dataset.direction;
      const height = element.dataset.height;
      const autoplay = element.dataset.autoplay === 'true';
      const autoplayintervel = parseInt(element.dataset.autoplayintervel);
      const type = element.dataset.type;
      const paginatione = element.dataset.pagination == 'true';

      // Banner check
      const isBanner = element.dataset.banner === 'yes';
      const mobileshow = isBanner ? 1 : 2;


      // 👉 Get custom breakpoint values
      const br1440 = parseInt(element.dataset['1440br']);
      const br1199 = parseInt(element.dataset['1199br']);
      const br989 = parseInt(element.dataset['989br']);
      const br767 = parseInt(element.dataset['767br']);
      const br576 = parseInt(element.dataset['576br']);

      const splide = new Splide(element, {
        type: type,
        perPage: perPage,
        arrows: arrows,
        pagination: paginatione,
        drag: drag,
        autoplay: autoplay,
        gap: gap,
        updateOnMove: true,
        interval: autoplayintervel || 3000,
        breakpoints: {
          1440: {
            pagination: paginatione,
            drag: true,
            perPage: isBanner ? mobileshow : (br1440 || perPage),
            gap: "16px"
          },
          1199: {
            pagination: paginatione,
            drag: true,
            perPage: isBanner ? mobileshow : (br1199 || mobileshow),
            gap: "16px"
          },
          989: {
            pagination: paginatione,
            drag: true,
            perPage: isBanner ? mobileshow : (br989 || mobileshow),
            gap: "16px"
          },
          767: {
            perPage: isBanner ? mobileshow : (br767 || mobileshow),
            arrows: arrows,
            pagination: paginatione,
            gap: "10px"
          },
          576: {
            perPage: isBanner ? mobileshow : (br576 || mobileshow),
            arrows: false,
            pagination: true
          }
        }
      });

      splide.on('mounted move resized', function () {

        const totalSlides = splide.length;
        const index = splide.index;
        const perPage = splide.options.perPage;
        const lastIndex = totalSlides - perPage;

        const prevArrow = element.querySelector('.splide__arrow--prev');
        const nextArrow = element.querySelector('.splide__arrow--next');

        if (!prevArrow || !nextArrow) return;

        // Hide arrows if all slides fit
        if (totalSlides <= perPage) {
          prevArrow.style.display = 'none';
          nextArrow.style.display = 'none';
          return;
        } else {
          prevArrow.style.display = '';
          nextArrow.style.display = '';
        }

        // Reset disabled state
        prevArrow.classList.remove('disabled');
        nextArrow.classList.remove('disabled');

        // Disable prev at first slide
        if (index === 0) {
          prevArrow.classList.add('disabled');
        }

        // Disable next at last slide
        if (index >= lastIndex) {
          nextArrow.classList.add('disabled');
        }

      });


      splide.mount();


    });

  };

  SplideSliderFunction();






  // brands tab
  document.querySelectorAll(".tab-main").forEach(function (tabMain) {

    tabMain.querySelectorAll(".cmn-tab").forEach(function (item) {

      item.addEventListener("click", function () {

        // Active class add and remove
        const tabId = this.getAttribute("data-id");
        this.classList.add("active");

        const tabParent = Array.from(this.parentElement.children);
        tabParent.forEach(function (sibling) {
          if (sibling !== item) {
            sibling.classList.remove("active");
          }
        });

        // Bottom process
        const nextSibling = Array.from(this.parentElement.nextElementSibling.children);

        nextSibling.forEach(function (infoItem) {

          const infoId = infoItem.getAttribute("data-id");

          if (infoId == tabId) {

            infoItem.style.display = "block";
            infoItem.classList.add("active");

            const infoParent = Array.from(infoItem.parentElement.children);

            infoParent.forEach(function (parentItem) {
              if (parentItem !== infoItem) {
                parentItem.style.display = "none";
                parentItem.classList.remove("active");
              }
            });

          }

        });

      });

    });

  });




  // index faq

  document.querySelectorAll(".index-faq").forEach(function (faqSection) {

    faqSection.querySelectorAll(".question").forEach(function (item) {

      item.addEventListener("click", function () {

        this.parentElement.classList.toggle("active");

        // Hide/Show answer
        const nextdiv = this.nextElementSibling;

        if (window.getComputedStyle(nextdiv).display == "none") {
          nextdiv.style.display = "block";
        } else {
          nextdiv.style.display = "none";
        }

        // Close other FAQs in the same section
        const topparent = this.parentElement.parentElement.children;

        for (let i = 0; i < topparent.length; i++) {

          const siblingcount = topparent[i];

          if (siblingcount != this.parentElement) {

            siblingcount.classList.remove("active");

            const dataText = siblingcount.querySelector(".answer");

            if (dataText) {
              dataText.style.display = "none";
            }

          }

        }

      });

    });

  });




  // index blog
  document.querySelectorAll(".blog-tag").forEach(function (tab) {

    tab.addEventListener("click", function () {

      const tabId = this.dataset.tab;

      // Active tab
      document.querySelectorAll(".blog-tag").forEach(function (btn) {
        btn.classList.remove("active");
      });

      this.classList.add("active");

      // Show/Hide content
      document.querySelectorAll(".tab-content").forEach(function (content) {

        if (content.dataset.tab === tabId) {

          content.style.display = "block";
          content.classList.add("active");

          // Refresh Splide
          const splideEl = content.querySelector(".splide");

          if (splideEl && splideEl.splide) {
            splideEl.splide.refresh();
          }

        } else {

          content.style.display = "none";
          content.classList.remove("active");

        }

      });

    });

  });





  // Contact checkbox
  const checkbox = document.getElementById("ContactForm-agree");
  const submitBtn = document.getElementById("ContactForm-submit");

  if (!checkbox || !submitBtn) return;

  submitBtn.disabled = true;

  checkbox.addEventListener("change", function () {
    submitBtn.disabled = !this.checked;
  });







  // end js
});